module.exports = __webpack_public_path__ + "img/quote-house.1fd624d0.gif";